"use strict";
/**
 * @module Services.TopicViews
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The response of TopicViews CREATE_TOPIC_VIEW service
 */
var CreateTopicViewResult = /** @class */ (function () {
    /**
     * Create a new CreateTopicViewResult instance
     *
     * @param view    the topic view
     * @param errors  any errors that might have occurred
     */
    function CreateTopicViewResult(view, errors) {
        this.view = view;
        this.errors = errors;
    }
    return CreateTopicViewResult;
}());
exports.CreateTopicViewResult = CreateTopicViewResult;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-views/create-topic-view-result.js
// module id = 1689
// module chunks = 1